(function () {
  'use strict';

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-pellavio-quick-add]')) return;
    e.preventDefault();
    if (form.classList.contains('is-loading')) return;

    var btn = form.querySelector('button');
    var btnSpan = btn ? btn.querySelector('span') : null;
    var origLabel = btnSpan ? btnSpan.textContent : '';

    form.classList.add('is-loading');
    if (btnSpan) btnSpan.textContent = 'Adding...';

    var formData = new FormData(form);
    var sections = [];
    var cartDrawer = document.querySelector('cart-drawer');
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (cartDrawer) sections.push('cart-drawer');
    if (cartIcon) sections.push('cart-icon-bubble');
    if (sections.length) formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          // Error from Shopify
          window.location.href = '/cart';
          return;
        }
        if (data.sections) {
          if (data.sections['cart-icon-bubble'] && cartIcon) {
            var iconHtml = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
            var iconReplacement = iconHtml.querySelector('#cart-icon-bubble');
            if (iconReplacement) cartIcon.innerHTML = iconReplacement.innerHTML;
          }
          if (data.sections['cart-drawer'] && cartDrawer) {
            var drawerHtml = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
            var drawerReplacement = drawerHtml.querySelector('cart-drawer');
            if (drawerReplacement) cartDrawer.innerHTML = drawerReplacement.innerHTML;
            cartDrawer.classList.remove('is-empty');
            if (typeof cartDrawer.open === 'function') {
              setTimeout(function () { cartDrawer.open(); }, 50);
            } else {
              cartDrawer.setAttribute('open', '');
              cartDrawer.classList.add('animate', 'active');
            }
          }
        }
      })
      .catch(function () {
        window.location.href = '/cart';
      })
      .finally(function () {
        form.classList.remove('is-loading');
        if (btnSpan) btnSpan.textContent = origLabel || 'Quick Add';
      });
  });
})();
